import { createStyles } from "@mantine/core";
import { colors } from "theme";

export const useStyles = createStyles(() => ({
  estimateGrid: {
    display: "grid",
    gridTemplateColumns: "2fr 1fr",
    alignItems: "center",
    gridTemplateRows: "55px",
    gridAutoRows: "30px",
    width: "100%",
  },
  operationRow: {
    borderTop: `1px solid ${colors.grey[10]}`,
    "&:last-of-type": {
      borderBottom: `1px solid ${colors.grey[10]}`,
    },
  },
  operation: {
    borderRadius: "16px",
    padding: "2px 10px",
    justifySelf: "flex-start",
  },
  operationGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
  },
}));
